import React, {useEffect, useState} from 'react';
import {useHistory} from "react-router-dom";
import TitleValue from "components/textValue/TitleValue";
import IconTextView from "components/input/IconTextView";
import DialogMessage from "components/dialogMessage/DialogMessage";
import {getSmallTextViewHeight, IsLP_MP_SP, IsNotLP_MP_SP} from "my-styles/media/media";
import {ALERT_TYPES} from "components/alertMassage/AlertMessage";
import {basketViewModel} from "../../../viewModels/Basket.viewModel";
import StandardButton from "components/buttons/StandardButton";
import {Divider} from "@material-ui/core";
import messages from "res/messages/farsi";

import ICTagBlue from "res/images/tag_blue.png";
import ICLogo from "res/images/logo_4.png";
import ICAddIcon from "res/images/add.png";
import ICRemoveIcon from "res/images/remove.png";
import ICDelete from "res/images/delete_red.png";

export default function BasketItem(props) {

    const history = useHistory()
    const product = props.product

    const [isCancelled, setIsCancelled] = useState(false)
    const [defaultSrc, setDefaultSrc] = useState(undefined)
    const [plusProgressIsShow, setPlusProgressIsShow] = useState(false)
    const [minusProgressIsShow, setMinusProgressIsShow] = useState(false)
    const [deleteProgressIsShow, setDeleteProgressIsShow] = useState(false)
    const [basketCount, setBasketCount] = useState(product ? product.basket_count : 0)
    const [deleteDialogShowStatus, setDeleteDialogShowStatus] = useState(false)

    function onProductClick() {
        props.onNavigate(history, "/productDetail?v=" + product.product_id)
    }

    function getPriceSection() {
        return <table className="horizontalFullScreen marginTopSmall" onClick={onProductClick}>
            <tbody>
            <tr>
                <td>
                    <TitleValue
                        title={messages.price}
                        titleClassName="mediumTextBold"
                        value={product.price_price ?
                            (product.price_price * product.basket_count).toLocaleString() + " " + messages.priceUnit :
                            (product.price * product.basket_count).toLocaleString() + " " + messages.priceUnit
                        }
                        valueClassName={"grayColor mediumTextBold"}
                    />
                </td>
                <td>
                    {(product.special > 0 || product.special_price > 0) &&
                    <TitleValue
                        title={messages.discount}
                        titleClassName="redColor mediumTextBold"
                        value={product.special_price > 0 ?
                            ((product.price_price - product.special_price) * product.basket_count).toLocaleString() + " " + messages.priceUnit :
                            (product.special > 0 && ((product.price - product.special) * product.basket_count).toLocaleString() + " " + messages.priceUnit)
                        }
                        valueClassName="redColor mediumTextBold"/>
                    }
                </td>
                {IsLP_MP_SP() &&
                <td>
                    {getOldPriceTag()}
                </td>
                }
            </tr>
            </tbody>
        </table>
    }

    function getOldPriceTag() {
        return <>
            {product.is_old_price > 0 &&
            <div onClick={onProductClick}
                 className="largeIcon center"
                 style={{position: "relative"}}>
                <img src={ICTagBlue} className="full" alt=""/>
                <label className="whiteColor smallText productDetailTag">
                    {messages.oldPrice}
                </label>
            </div>
            }
        </>
    }

    function getBasketButtons() {
        return <div className="center horizontalScreen toLeft">
            <div className="marginSmall">
                <StandardButton
                    loading={plusProgressIsShow}
                    icon={<img className="xSmallIcon_1" src={ICAddIcon} alt={"صرفه مارکت"}/>}
                    onClick={() => {
                        if (basketCount >= product.limit_count) {
                            props.onAlert(messages.productIsLimit, ALERT_TYPES.WARNING)
                        } else {
                            basketViewModel.plusToBasket(product, () => {

                            }, () => {
                                props.onAlert(messages.responseCodeIsNot200)
                            }, () => {
                                setPlusProgressIsShow(true)
                            }, () => {
                                setPlusProgressIsShow(false)
                            })
                        }
                    }}/>
            </div>
            <div className="center largeTextBold blueColor_2 marginTopBottomSmall" style={{width: "6em"}}>
                <IconTextView
                    height={getSmallTextViewHeight()}
                    placeholder={messages.count}
                    center={true}
                    value={basketCount}
                    onChange={(e) => {
                        e.target.value = e.target.value.replace(/^\D+/g, '')
                        if (e.target.value === "0") {
                            setDeleteDialogShowStatus(true)
                        } else if (e.target.value === "") {
                            setBasketCount("")
                        } else if (e.target.value === product.basket_count) {
                            setBasketCount("1000")
                        } else {
                            if (e.target.value > product.limit_count) {
                                props.onAlert(messages.productIsLimit, ALERT_TYPES.WARNING)
                            } else {
                                basketViewModel.setQuantityToBasket(product, e.target.value, () => {

                                }, () => {
                                    props.onAlert(messages.responseCodeIsNot200)
                                }, () => {
                                    props.onLoading(true)
                                }, () => {
                                    props.onLoading(false)
                                })
                            }
                        }
                    }}/>
            </div>
            <div className="marginSmall">
                <StandardButton
                    loading={minusProgressIsShow}
                    icon={<img className="xSmallIcon_1" src={ICRemoveIcon} alt={"صرفه مارکت"}/>}
                    onClick={() => {
                        basketViewModel.removeFromBasket(product, () => {

                        }, () => {
                            props.onAlert(messages.responseCodeIsNot200)
                        }, () => {
                            setMinusProgressIsShow(true)
                        }, () => {
                            setMinusProgressIsShow(false)
                        })
                    }}/>
            </div>
            <div className="marginSmall">
                <Divider orientation="vertical"/>
            </div>
            <div className="marginSmall">
                <StandardButton
                    loading={deleteProgressIsShow}
                    icon={<img className="xSmallIcon_1" src={ICDelete} alt={"صرفه مارکت"}/>}
                    onClick={() => {
                        setDeleteDialogShowStatus(true)
                    }}/>
            </div>
        </div>
    }

    function getImage() {
        return <div onClick={onProductClick}>

            {IsNotLP_MP_SP() &&
            <div style={{position: "absolute", top: 0, right: 0}}>
                {getOldPriceTag()}
            </div>
            }
            <img
                className="marginSmall"
                style={{height: "5em"}}
                src={defaultSrc ? defaultSrc : product.image}
                onError={() => {
                    setDefaultSrc(ICLogo)
                }}
                alt=""/>
        </div>
    }

    function getName() {
        return <div className="mediumTextBold marginSmall" onClick={onProductClick}>
            {product.name}
        </div>
    }

    useEffect(() => {
        basketViewModel.product.subscribe(() => {
            if (isCancelled) return

            let localProducts = basketViewModel.getLocalBasket()
            if (localProducts) {
                if (product) {
                    let index = localProducts.findIndex((element) =>
                        element.product_id === product.product_id
                    )
                    if (index >= 0) {
                        setBasketCount(localProducts[index].basket_count)
                    } else {
                        setBasketCount(0)
                    }
                }
            } else {
                setBasketCount(0)
            }

            return () => {
                setIsCancelled(true)
            }
        })
    }, [product, isCancelled])

    return (<div className="card marginTopSmall horizontalFullScreen">
        {getImage()}
        <div className="marginTopBottomSmall">
            <Divider orientation="vertical"/>
        </div>
        <div className="fullWidth" style={{position: "relative"}}>
            {getName()}
            {getPriceSection()}
            {getBasketButtons()}
        </div>
        <DialogMessage
            showStatus={deleteDialogShowStatus}
            title={messages.deleteFromCart}
            message={messages.sureDeleteFromCart}
            submitTitle={messages.yes}
            closeTitle={messages.no}
            onCloseClicked={() => {
                setDeleteDialogShowStatus(false)
            }}
            onSubmitClicked={() => {
                setDeleteDialogShowStatus(false)
                basketViewModel.deleteFromBasket(product, () => {

                }, () => {
                    props.onAlert(messages.responseCodeIsNot200)
                }, () => {
                    setDeleteProgressIsShow(true)
                }, () => {
                    setDeleteProgressIsShow(false)
                })
            }}
        />
    </div>)

}